import { render, staticRenderFns } from "./PopupSalonRating.vue?vue&type=template&id=8b493a44&scoped=true&"
import script from "./PopupSalonRating.vue?vue&type=script&lang=js&"
export * from "./PopupSalonRating.vue?vue&type=script&lang=js&"
import style0 from "./PopupSalonRating.vue?vue&type=style&index=0&id=8b493a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b493a44",
  null
  
)

export default component.exports